import { styled } from 'styled-components'

import { onSurface } from 'core/styles'

export const FormRow = styled.div<{ $variant?: 'horizontal' | 'vertical' }>`
  display: flex;
  flex-direction: ${(p) => (p.$variant === 'horizontal' ? 'row' : 'column')};
  align-items: start;
  justify-content: space-between;
  padding-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
  }
`

export const FormValue = styled.span`
  color: ${onSurface};
  font-size: 14px;
  font-weight: 600;
`

export const FieldLabel = styled.label`
  display: block;
  padding-bottom: 2px;
  color: ${onSurface};
  font-size: 13px;
  font-weight: 500;
`
